import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { parseAmount } from '@kraftwerk/shared';
import { db } from '../../db/local.js';
import { recordShoppingExpense } from '../../db/costs.js';
import { useToday } from '../../hooks/useToday.js';

/**
 * Nach dem Einkauf (E17): „Was hat es gekostet?“ — bezahlt hat, wer abhakt.
 * Ändern geht danach unter Kosten. Überspringen ist erlaubt und still: Kein
 * Betrag ist kein Betrag, nicht 0 €.
 */
export function ShoppingCostPrompt({
  householdId,
  onDone,
}: {
  householdId: string | null;
  onDone: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const today = useToday();
  const amountId = useId();
  const [amount, setAmount] = useState('');
  const cents = parseAmount(amount);

  return (
    <form
      className="kw-tile flex flex-col gap-2 border-accent"
      onSubmit={(event) => {
        event.preventDefault();
        if (cents === null || !today) return;
        void recordShoppingExpense(cents, today, householdId, db).then(onDone);
      }}
    >
      <label htmlFor={amountId} className="font-medium">
        {t('costs.shoppingQuestion')}
      </label>
      <p className="text-xs text-ink-muted">{t('costs.shoppingHint')}</p>
      <div className="flex gap-2">
        <input
          id={amountId}
          inputMode="decimal"
          value={amount}
          onChange={(event) => setAmount(event.target.value)}
          placeholder="0,00"
          className="kw-field min-w-0 flex-1 font-display text-xl"
        />
        <button
          type="submit"
          disabled={cents === null}
          className="kw-btn kw-btn-small shrink-0 px-4"
        >
          {t('costs.addSubmit')}
        </button>
      </div>
      <button type="button" onClick={onDone} className="kw-btn kw-btn-quiet kw-btn-small">
        {t('costs.skip')}
      </button>
    </form>
  );
}
